import React from 'react';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import AlertBanners from './AlertBanners';
import FactoryModals from './FactoryModals';

const NotificationFactory = () => {
    const { alerts, pop: closeAlert } = useAlertBanner();
    const { modals, pop: closeModal } = useReduxModal();

    return (
        <>
            <AlertBanners alerts={alerts} defaultOnClose={closeAlert} />
            <FactoryModals modals={modals} defaultOnClose={closeModal} />
        </>
    );
};

export default NotificationFactory;
